import * as React from 'react';
export var Thumbnails = function Thumbnails(_a) {
  var className = _a.className;
  return React.createElement("svg", {
    className: className,
    width: "16",
    height: "16",
    viewBox: "0 0 48 48"
  }, React.createElement("g", null, React.createElement("rect", {
    y: "6",
    width: "13",
    height: "9"
  }), React.createElement("rect", {
    x: "17.5",
    y: "6",
    width: "13",
    height: "9"
  }), React.createElement("rect", {
    x: "35",
    y: "6",
    width: "13",
    height: "9"
  }), React.createElement("rect", {
    y: "19.5",
    width: "13",
    height: "9"
  }), React.createElement("rect", {
    x: "17.5",
    y: "19.5",
    width: "13",
    height: "9"
  }), React.createElement("rect", {
    x: "35",
    y: "19.5",
    width: "13",
    height: "9"
  }), React.createElement("rect", {
    y: "33",
    width: "13",
    height: "9"
  }), React.createElement("rect", {
    x: "17.5",
    y: "33",
    width: "13",
    height: "9"
  }), React.createElement("rect", {
    x: "35",
    y: "33",
    width: "13",
    height: "9"
  })));
};